<template>
    <div class="w-full">
        <div class="flex justify-between items-center">
            <Back />
            <a
            @click.prevent="nextStep"
            class="focus:outline-none cursor-pointer text-white text-sm py-1 px-2 rounded-md bg-red-500 hover:bg-red-600 hover:shadow-lg flex items-center"
            
            >
                Selanjutnya : {{whatsNext == '' ? 'Selesai' : 'Tambah ' + whatsNext}}
                <i class="fas fa-arrow-right ml-2"></i>
            </a>
        </div>
        
        <Step
            :classroom="classroom"
            :step="step"
        />
        <div class="mx-auto">
            <div class="w-full mt-5">
                
                <div class="md:grid md:grid-cols-3 md:gap-6">
                    <div class="md:col-span-1">
                        <p class="mb-2">Form Video</p>
                        <form action="#" method="POST">
                            <div class="shadow sm:rounded-md sm:overflow-hidden">
                                <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
                                    <div class="w-full">
                                        <div class="col-span-6 sm:col-span-3">
                                            <label for="first_name"
                                                class="block text-sm font-medium text-gray-700">Judul Video</label>
                                            <input v-model="formSubject.title" type="text" name="first_name"
                                                id="first_name" autocomplete="given-name"
                                                placeholder="Nama judul video"
                                                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                        </div>
                                    </div>
                                      <div class="w-full">
                                        <div class="col-span-6 sm:col-span-3">
                                            <label for="first_name"
                                                class="block text-sm font-medium text-gray-700">Slug</label>
                                            <input v-model="formSubject.slug" type="text" name="slug"
                                                id="slug" autocomplete="slug"
                                                placeholder="nama-slug-video"
                                                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                            <p class="text-sm text-gray-500 mt-1">
                                                Contoh slug: https://video.sekolahdesain.id/<span class="font-semibold text-red-500">nama-slug-video</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div v-if="formSubject.video && format == 'link'" class="w-ful">
                                        <label class="block text-sm font-medium text-gray-700">Preview Video</label>
                                        <div v-safe-html="formSubject.video"></div>
                                        <!-- <vue-plyr 
                                            class="w-full"
                                            :options="options"
                                        >
                                            <video
                                                controls
                                                playsinline
                                            >
                                                <source :src="formSubject.video" />
                                            </video>
                                        </vue-plyr> -->
                                    </div>

                                    <div class="w-full">
                                        <label for="country" class="block text-sm font-medium text-gray-700">Pilih Format Upload</label>
                                        <select id="format" name="format" autocomplete="format" v-model="format"
                                            class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                            <option value="video">Video</option>
                                            <option value="link">Link</option>
                                        </select>
                                    </div>

                                    <div v-if="format === 'link'" class="w-full">

                                        <label for="link" class="block text-sm font-medium text-gray-700">
                                            Link
                                        </label>
                                        <textarea v-model="formSubject.video" type="text" name="link" id="link"
                                            placeholder="https://video.sekolahdesain.id/nama-file.mp4"
                                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"> </textarea>
                                    </div>

                                    <div v-else class="w-full">
                                        <label for="video" class="block text-sm font-medium text-gray-700">
                                            Video
                                        </label>

                                        <input @change="uploadVideo($event)" ref="videoUpload" type='file' name="video" id="video"
                                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                                    </div>

                                    <!-- <div class="w-full">
                                        <label for="question" class="block text-sm font-medium text-gray-700">
                                            Resolusi Video
                                        </label>
                                        <div class="mt-1">
                                            <select id="resolusi" name="resolusi" autocomplete="resolusi" v-model="resolution"
                                                class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                                <option v-for="(res, i) in resolutions" :value="res" :key="i">{{ res }}</option>
                                            </select>
                                        </div>
                                    </div> -->

                                    <div class="w-full">
                                        <label for="link" class="block text-sm font-medium text-gray-700">
                                            Thumbnail
                                        </label>
                                        <div v-if="formSubject.thumbnail">
                                            <img :src="formSubject.thumbnail" class="w-full" alt="">
                                        </div>
                                        <input @change="uploadThumbnail($event)" ref="thumbnailUpload" type='file' name="thumbnail"
                                            id="thumbnail"
                                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />

                                    </div>
                                    <div class="w-full">
                                        <div class="col-span-6 sm:col-span-3">
                                            <label for="duration"
                                                class="block text-sm font-medium text-gray-700">Durasi</label>
                                            <InputMask
                                                v-model="formSubject.duration"
                                                placeholder="59:59"
                                                mask="99:99"
                                                slotChar="00:00"
                                                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                            />
                                            <p class="text-sm text-gray-600 mt-1">Durasi maksimal <span class="font-semibold text-red-500">59:59</span></p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="showUploadProgress" class="relative pt-1 px-4 bg-white">
                                    <div class="flex mb-2 items-center justify-between">
                                        <div>
                                        <span class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-green-700 bg-green-200">
                                            Upload in progress
                                        </span>
                                        </div>
                                        <div class="text-right">
                                        <span class="text-xs font-semibold inline-block text-green-600">
                                            {{uploadPercentage}}%
                                        </span>
                                        </div>
                                    </div>
                                    <div class="overflow-hidden h-2 mb-2 text-xs flex rounded bg-gray-200">
                                        <div :style="'width:'+uploadPercentage+'%'" class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-500"></div>
                                    </div>
                                </div>
                                <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                    <button 
                                        @click.prevent="submit" 
                                        type="submit"
                                        class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 items-center disabled:opacity-80 disabled:cursor-wait"
                                        :disabled="showUploadProgress"
                                    >
                                        Tambah
                                        <i v-if="showUploadProgress" class="fas fa-spinner animate-spin ml-1"></i>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="mt-3 md:mt-0 md:col-span-2">
                        <p class="mb-2">Daftar Video</p>
                        <div class="p-3 bg-white shadow sm:rounded-md sm:overflow-hidden">
                            <DataTable 
                                :value="videos"  
                                @rowReorder="onRowReorder" 
                                responsiveLayout="scroll" 
                                class="p-datatable-sm font-sans text-sm"
                                dataKey="id"
                                @rowExpand="onRowExpand"
                                v-model:expandedRows="expandedVideo"
                            >
                                <template #empty>
                                    No Data found.
                                </template>
                                <template #loading>
                                    Loading video data. Please wait.
                                </template>
                                <Column v-for="col of columns" :field="col.field" :header="col.header" :key="col.field"></Column>
                                <Column :expander="true" headerStyle="width: 5rem" bodyStyle="text-align: center!important;"  header="Resolusi & Asset" />
                                <Column field="id" header="Aksi" headerStyle="width: 8rem;">
                                    <template #body="{data}">
                                        <a @click="showEditVideo(data.id)" type="button" class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-2 py-1 bg-yellow-600 text-base font-medium text-white hover:bg-yellow-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:w-auto sm:text-sm">
                                            <i class="fas fa-edit"></i>
                                        </a>
                                        <a @click="showDeleteVideo(data.id)" type="button" class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-2 py-1 bg-red-600 text-base font-medium text-white hover:bg-red-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-2 sm:w-auto sm:text-sm">
                                            <i class="fas fa-trash-alt"></i>
                                        </a>
                                        <a @click="videoPreview(data, 0)" type="button" class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-2 py-1 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-2 sm:w-auto sm:text-sm">
                                            <i class="fas fa-play-circle"></i>
                                        </a>
                                    </template>
                                </Column>
                                <Column :rowReorder="true" headerStyle="width: 2rem;" :reorderableColumn="false" class="cursor-move px-0" />
                                <template #expansion="slotProps">
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                                        <DataTable
                                            :value="slotProps.data.resolutions"
                                            responsiveLayout="scroll"
                                            dataKey="id"
                                            :rowHover="true"
                                            class="p-datatable-sm font-sans text-sm m-0 p-0 border border-gray-200 col-span-1"
                                        >
                                            <template #header>
                                                <div class="flex items-center justify-between">
                                                    <p class="text-base">Resolusi Video</p>
                                                    <button type="button"
                                                        @click="addNewResolution"
                                                        class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-2 py-1 text-sm font-medium text-white bg-green-600 hover:bg-green-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600 sm:ml-3 sm:w-auto items-center"
                                                    >
                                                        <i class="fas fa-plus mr-2"></i>
                                                        Tambah Resolusi
                                                    </button>
                                                </div>
                                            </template>
                                            <template #empty>
                                                <div class="text-center font-bold">
                                                    Belum ada resolusi
                                                </div>
                                            </template>
                                            <Column field="file" headerStyle="text-align: center!important;" header="Resolusi">
                                                <template #body="{data}">
                                                    <a :href="data.link" target="_blank" class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-full inline-flex items-center text-xs">
                                                        {{ data.resolution }}
                                                    </a>
                                                </template>
                                            </Column>
                                            <Column field="file" headerStyle="width: 8rem;" header="Aksi">
                                                <template #body="{data}">
                                                    <a @click="showEditResolution(data)" type="button" class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-2 py-1 bg-yellow-600 text-base font-medium text-white hover:bg-yellow-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:w-auto sm:text-sm">
                                                        <i class="fas fa-edit"></i>
                                                    </a>
                                                    <a @click="showDeleteResolution(data)" type="button" class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-2 py-1 bg-red-600 text-base font-medium text-white hover:bg-red-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-2 sm:w-auto sm:text-sm">
                                                        <i class="fas fa-trash-alt"></i>
                                                    </a>
                                                    <a @click="videoPreview(slotProps.data, data.id)" type="button" class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-2 py-1 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-2 sm:w-auto sm:text-sm">
                                                        <i class="fas fa-play-circle"></i>
                                                    </a>
                                                </template>
                                            </Column>
                                        </DataTable>
                                        <DataTable
                                            :value="slotProps.data.assets"
                                            responsiveLayout="scroll"
                                            dataKey="id"
                                            :rowHover="true"
                                            class="p-datatable-sm font-sans text-sm m-0 p-0 border border-gray-200 col-span-1"
                                        >
                                            <template #header>
                                                <div class="flex items-center justify-between">
                                                    <p class="text-base">List Assets</p>
                                                    <button type="button"
                                                        @click="addNewAsset"
                                                        class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-2 py-1 text-sm font-medium text-white bg-green-600 hover:bg-green-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600 sm:ml-3 sm:w-auto items-center"
                                                    >
                                                        <i class="fas fa-plus mr-2"></i>
                                                        Tambah Asset
                                                    </button>
                                                </div>
                                            </template>
                                            <template #empty>
                                                <div class="text-center font-bold">
                                                    Belum ada asset
                                                </div>
                                            </template>
                                            <!-- <Column field="name" header="Nama Asset" /> -->
                                            <Column field="file" header="File Asset">
                                                <template #body="{data}">
                                                    <a :href="data.file" target="_blank" class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center text-xs">
                                                        <span>{{ data.name }}</span>
                                                        <i class="fas fa-download ml-2"></i>
                                                    </a>
                                                </template>
                                            </Column>
                                        </DataTable>
                                    </div>
                                </template>
                            </DataTable>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <!-- modal preview -->
        <transition name="pop">
        <div
            v-if="videoPreviewModal"
            class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
        >
            <div class="relative w-3/4 md:w-1/2 my-6 mx-auto">
                <div v-click-away="closeVideoPreview" class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    <div
                    class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700">
                        <h3 class="text-xl font-semibold text-white">
                            Video Preview
                        </h3>
                        <button
                            class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                            v-on:click="closeVideoPreview()">
                            <i class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"></i>
                        </button>
                    </div>
                    <div class="relative px-6 pt-3 pb-6">
                        <div class="w-full pb-2">
                            <span class="font-bold">
                                {{ selectedVideo?.title }}
                            </span>
                        </div>
                        <div class="w-full pb-3">
                            <div v-if="selectedVideo?.video.includes('iframe')" v-safe-html="selectedVideo?.video"></div>
                            <vue-plyr v-else>
                                <video
                                    controls
                                    playsinline
                                >
                                    <source :src="selectedVideo?.video" />
                                </video>
                            </vue-plyr>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </transition>
        <Delete
            :display="displayDeleteVideo"
            title="Delete Video?"
            note=""
            :close="closeDeleteVideo"
            :deleteBtn="videoDelete"
        />
        <!-- modal edit video -->
        <transition name="pop">
        <div v-if="displayEditVideo"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
            <div class="relative w-3/4 md:w-2/3 m-auto">
                <div class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-85">
                    <div
                        class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700">
                        <h3 class="text-xl font-semibold text-white">
                            Ubah Video
                        </h3>
                        <button
                        class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                        v-on:click="closeEditVideo">
                        <i class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"></i>
                        </button>
                    </div>
                    <div class="relative px-6 py-3 overflow-x-hidden overflow-y-auto">
                        <div class="grid grid-cols-2 gap-4">
                            <div>
                                <div class="w-full pb-3">
                                    <label for="title" class="block text-sm font-medium text-gray-700">Judul Modul</label>
                                    <input v-model="formSubjectEdit.title" type="text" name="title_edit" id="title_edit" autocomplete="given-name"
                                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="Nama judul video">
                                </div>
                                <div class="w-full pb-3">
                                    <label for="slug" class="block text-sm font-medium text-gray-700">Slug</label>
                                    <input v-model="formSubjectEdit.slug" type="text" name="slug_edit" id="slug_edit" autocomplete="given-name"
                                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="nama-slug-video">
                                    <p class="text-sm text-gray-500 mt-1">
                                        Contoh slug: https://video.sekolahdesain.id/<span class="font-semibold text-red-500">nama-slug-video</span>
                                    </p>
                                </div>

                                <div class="w-full pb-3">
                                    <label for="link" class="block text-sm font-medium text-gray-700">
                                        Thumbnail
                                    </label>
                                    <div v-if="formSubjectEdit.thumbnail">
                                        <img :src="formSubjectEdit.thumbnail" class="h-32" alt="">
                                    </div>
                                    <input @change="uploadThumbnailEdit($event)" ref="thumbnailUploadEdit" type='file' name="thumbnail"
                                        id="thumbnail"
                                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />

                                </div>
                                <div class="w-full pb-3">
                                    <div class="col-span-6 sm:col-span-3">
                                        <label for="duration"
                                            class="block text-sm font-medium text-gray-700">Durasi</label>
                                        <InputMask
                                            v-model="formSubjectEdit.duration"
                                            placeholder="59:59"
                                            mask="99:99"
                                            slotChar="00:00"
                                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                        />
                                        <p class="text-sm text-gray-600 mt-1">Durasi maksimal <span class="font-semibold text-red-500">59:59</span></p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="w-full pb-3">
                                    <label for="country" class="block text-sm font-medium text-gray-700">Pilih Format Upload</label>
                                    <select id="format" name="format" autocomplete="format" v-model="format"
                                        class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                        <option value="video">Video</option>
                                        <option value="link">Link</option>
                                    </select>
                                </div>
            
                                <div v-if="formSubjectEdit.video && format == 'link'" class="w-full pb-3">
                                    <label class="block text-sm font-medium text-gray-700">Preview Video</label>
                                    <div v-safe-html="formSubjectEdit.video"></div>
                                    <!-- <vue-plyr 
                                        class="w-full"
                                        :options="options"
                                    >
                                        <video
                                            controls
                                            playsinline
                                        >
                                            <source :src="formSubjectEdit.video" />
                                        </video>
                                    </vue-plyr> -->
                                </div>

                                <!-- <div class="w-full pb-3">
                                    <label for="country" class="block text-sm font-medium text-gray-700">Pilih
                                        Format Upload</label>
                                    <select id="format_edit" name="format_edit" autocomplete="format" v-model="format"
                                        class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                        <option value="video">Video</option>
                                        <option value="link">Link</option>
                                    </select>
                                </div> -->

                                <div v-if="format === 'link'" class="w-full">
                                    <label for="link" class="block text-sm font-medium text-gray-700">
                                        Link
                                    </label>
                                    <textarea v-model="formSubjectEdit.video" type="text" name="link_edit" id="link_edit"
                                        placeholder="https://video.sekolahdesain.id/nama-file.mp4"
                                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"> </textarea>
                                </div>

                                <div v-else class="w-full">
                                    <label for="video" class="block text-sm font-medium text-gray-700">
                                        Video
                                    </label>

                                    <input @change="uploadVideoEdit($event)" ref="videoUploadEdit" type='file' name="video" id="video"
                                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                                </div>


                                <div v-if="showUploadProgressUpdate" class="relative pt-1 bg-white mt-5">
                                    <div class="flex mb-2 items-center justify-between">
                                        <div>
                                            <span class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-green-700 bg-green-200">
                                                Upload in progress
                                            </span>
                                        </div>
                                        <div class="text-right">
                                            <span class="text-xs font-semibold inline-block text-green-600">
                                                {{uploadPercentageUpdate}}%
                                            </span>
                                        </div>
                                    </div>
                                    <div class="overflow-hidden h-2 mb-2 text-xs flex rounded bg-gray-200">
                                        <div :style="'width:'+uploadPercentageUpdate+'%'" class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-500"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="text-right px-6 py-3">
                        <button @click.prevent="submitEdit"
                            class="inline-flex justify-center text-white border border-solid font-bold text-sm px-3 py-1.5 rounded outline-none focus:outline-none bg-yellow-500 border-yellow-500 hover:bg-yellow-600 active:bg-yellow-600 items-center disabled:opacity-80 disabled:cursor-wait"
                            type="button" 
                            style="transition: all .15s ease"
                            :disabled="showUploadProgressUpdate"
                        >
                            Ubah
                            <i v-if="showUploadProgressUpdate" class="fas fa-spinner animate-spin ml-1"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        </transition>

        <!-- modal asset -->
        <transition name="pop">
        <div v-if="displayModalAsset"
            class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
            <div class="relative w-3/4 md:w-1/3 m-auto">
                <div class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    <div
                        class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700">
                        <h3 class="text-xl font-semibold text-white">
                            Tambah Asset
                        </h3>
                        <button
                        class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                        v-on:click="closeModalAsset">
                            <i class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"></i>
                        </button>
                    </div>
                    <div class="relative px-6 py-3 overflow-y-auto overflow-x-hidden">
                        <div class="w-full pb-3">
                            <label for="question" class="block text-sm font-medium text-gray-700">
                                Nama Asset<span class="text-red-600 font-bold">*</span>
                            </label>
                            <div class="mt-1">
                                <input type="text" placeholder="Nama asset"
                                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                v-model="formAsset.name" />
                            </div>
                        </div>
                        <div class="w-full pb-3">
                            <label for="question" class="block text-sm font-medium text-gray-700">
                                File<span class="text-red-600 font-bold">*</span>
                            </label>
                            <div class="mt-1">
                                <input @change="uploadAsset($event)" ref="assetUpload" type='file' name="asset" id="asset"
                                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                            </div>
                        </div>
                    </div>
                    <div class="flex p-3" :class="showUploadProgressAsset ? 'justify-between' : 'justify-end'"> 
                        <div v-if="showUploadProgressAsset" class="relative bg-white w-full">
                            <div class="flex mb-1 items-center justify-between">
                                <div>
                                    <span class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-green-700 bg-green-200">
                                        Upload in progress
                                    </span>
                                </div>
                                <div class="text-right">
                                    <span class="text-xs font-semibold inline-block text-green-600">
                                        {{uploadPercentageAsset}}%
                                    </span>
                                </div>
                            </div>
                            <div class="overflow-hidden h-1 text-xs flex rounded bg-gray-200">
                                <div :style="'width:'+uploadPercentageAsset+'%'" class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-500"></div>
                            </div>
                        </div>
                        <div class="text-right self-center ml-3">
                            <button @click.prevent="submitAsset"
                                class="inline-flex justify-center text-white border border-solid font-bold text-sm px-3 py-1.5 rounded outline-none focus:outline-none bg-red-500 border-red-500 hover:bg-red-600 active:bg-red-600 items-center disabled:opacity-80 disabled:cursor-wait"
                                type="button" 
                                style="transition: all .15s ease"
                                :disabled="showUploadProgressAsset"
                            >
                                Tambah
                                <i v-if="showUploadProgressAsset" class="fas fa-spinner animate-spin ml-1"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </transition>

        <!-- modal resolution -->
        <transition name="pop">
        <div v-if="displayModalResolution"
            class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
            <div class="relative w-3/4 md:w-1/3 m-auto">
                <div class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    <div
                        class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700">
                        <h3 class="text-xl font-semibold text-white">
                            {{ resolutionId > 0 ? 'Ubah Resolusi Video' : 'Tambah Resolusi Video' }}
                        </h3>
                        <button
                        class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                        v-on:click="closeModalResolution">
                            <i class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"></i>
                        </button>
                    </div>
                    <div class="relative px-6 py-3 overflow-y-auto overflow-x-hidden">
                        <div class="w-full pb-3">
                            <label for="question" class="block text-sm font-medium text-gray-700">
                                Resolusi Video<span class="text-red-600 font-bold">*</span>
                            </label>
                            <div class="mt-1">
                                <select id="resolusi" name="resolusi" autocomplete="resolusi" v-model="formResolution.resolution"
                                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                    <option v-for="(res, i) in resolutions" :value="res" :key="i">{{ res }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="w-full pb-3">
                            <div class="flex justify-between items-center">
                                <label for="question" class="block text-sm font-medium text-gray-700">
                                    Video<span class="text-red-600 font-bold">*</span>
                                </label>
                                <div>
                                    <label for="toggle"  class="text-xs text-gray-700 mr-2 cursor-pointer" :class="!useFile ? 'font-bold':''" >Link</label>
                                    <div class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                                        <input type="checkbox" name="toggle" id="toggle" v-model="useFile" class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"/>
                                        <label for="toggle" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"></label>
                                    </div>
                                    <label for="toggle" class="text-xs text-gray-700 ml-2 cursor-pointer" :class="useFile ? 'font-bold':'' ">File</label>
                                </div>
                            </div>
                            <div class="mt-1">
                                <input v-if="useFile" @change="uploadResolution($event)" ref="resolutionUpload" type='file' name="resolution" id="resolution"
                                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                                <textarea v-else name="" id="" rows="2" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" v-model="formResolution.link" placeholder="Link Video"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="flex p-3" :class="showUploadProgressResolution ? 'justify-between' : 'justify-end'"> 
                        <div v-if="showUploadProgressResolution" class="relative bg-white w-full">
                            <div class="flex mb-1 items-center justify-between">
                                <div>
                                    <span class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-green-700 bg-green-200">
                                        Upload in progress
                                    </span>
                                </div>
                                <div class="text-right">
                                    <span class="text-xs font-semibold inline-block text-green-600">
                                        {{uploadPercentageResolution}}%
                                    </span>
                                </div>
                            </div>
                            <div class="overflow-hidden h-1 text-xs flex rounded bg-gray-200">
                                <div :style="'width:'+uploadPercentageResolution+'%'" class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-500"></div>
                            </div>
                        </div>
                        <div class="text-right self-center ml-3">
                            <button @click.prevent="submitResolution"
                                class="inline-flex justify-center text-white border border-solid font-bold text-sm px-3 py-1.5 rounded outline-none focus:outline-none items-center disabled:opacity-80 disabled:cursor-wait"
                                type="button" 
                                style="transition: all .15s ease"
                                :disabled="showUploadProgressResolution"
                                :class="resolutionId > 0 ? 'bg-yellow-500 border-yellow-500 hover:bg-yellow-600 active:bg-yellow-600' : 'bg-red-500 border-red-500 hover:bg-red-600 active:bg-red-600' "
                            >
                                {{ resolutionId > 0 ? 'Ubah' : 'Tambah' }}
                                <i v-if="showUploadProgressResolution" class="fas fa-spinner animate-spin ml-1"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </transition>

        <Delete
            :display="displayDeleteResolution"
            title="Delete Resolusi Video?"
            :note="formResolution?.resolution"
            :close="closeDeleteResolution"
            :deleteBtn="resolutionDelete"
        />
        <Toast />
    </div>
</template>
<script>
                  
import Back from '@/layout/Component/Back'
import Step from '@/layout/Component/Step'
import Delete from '@/layout/Component/Delete'
import moment from 'moment'
import { getAccessToken } from "@/utils/accessToken";
import axios from 'axios'

import {
    mapActions,
    mapGetters
} from 'vuex'

export default {

    components: {
        Back,
        Step,
        Delete,
    },

    data() {
        return {
            format: 'video',
            formSubject: {
                title: '',
                slug: '',
                classroomId: 0,
                classroomLevelId: 0,
                publishedAt: moment().format('YYYY-MM-DD HH:mm:00'),
                shortDescription: '',
                description: '',
                thumbnail: '',
                video: '',
                link: '',
                duration: '',
                isActive: true,
                status: 1,
                ordering: 0,
            },
            formSubjectEdit: {
                title: '',
                slug: '',
                classroomId: 0,
                classroomLevelId: 0,
                publishedAt: moment().format('YYYY-MM-DD HH:mm:00'),
                shortDescription: '',
                description: '',
                thumbnail: '',
                video: '',
                link: '',
                duration: '',
                isActive: true,
                status: 1,
                ordering: 0,
            },
            videoId: 0,
            videos: null,
             columns: [ 
                {
                    field: 'ordering', 
                    header: 'Urutan'
                },
                {
                    field: 'id', 
                    header: 'ID'
                },
                {
                    field: 'title', 
                    header: 'Judul'
                },
                {
                    field: 'duration', 
                    header: 'Durasi'
                },
            ],
            classroomLevel: {},
            whatsNext: '',
            step: 1,
            selectedVideo: {},
            videoPreviewModal: false,
            options: {
                settings: [],
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'airplay', 'fullscreen']
            },
            displayDeleteVideo: false,
            displayEditVideo: false,
            uploadPercentage: 0,
            uploadPercentageUpdate: 0,
            showUploadProgress: false,
            showUploadProgressUpdate: false,
            expandedVideo: [],
            displayModalAsset: false,
            formAsset: {
                name: '',
                file: null,
            },
            showUploadProgressAsset: false,
            uploadPercentageAsset: 0,
            displayModalResolution: false,
            displayDeleteResolution: false,
            showUploadProgressResolution: false,
            uploadPercentageResolution: 0,
            formResolution: {
                resolution: '',
                link: '',
            },
            resolutions: [
                360,
                480,
                720,
                1080,
            ],
            resolutionId: 0,
            useFile: true,
            videoResolutionFile: null,
            resolution: ''
        }
    },
    async created() {
        this.classroomId = this.$route.params.classroomId
        if (this.classroomId && (this.classroom?.id != this.classroomId)) {
            this.getClassroomDetail()
        } else {
            this.next()
        }
        if ((this.videoList?.length == 0) || (this.savedIdClassroomVideo != this.classroomId)) {
            await this.fetchAllVideos(this.classroomId)
        }
        this.videos = this.videoList
    },
    computed: {
        ...mapGetters(["classroom", "video", "isLoadingVideo", "isSuccessVideo", "messageVideo", "videoList", "videoPagination", "savedIdClassroomVideo" ]),
   },
    
    methods: {
        ...mapActions(["fetchDetailClassroom", "fetchAllVideos", "fetchDetailVideo",  "addVideo", "updateVideo", "deleteVideo", "addAssetVideo", "removeResolution"]),
        async getClassroomDetail() {
            await this.fetchDetailClassroom(this.classroomId)
           
            this.next()
        },
        next() {
              if(this.classroom?.must_module_tab) {
                  this.whatsNext = 'modul'
                    
                } else if(this.classroom?.must_quiz_tab) {
                    this.whatsNext = 'quiz'
                    
                } else if(this.classroom?.must_webinar_tab) {
                    this.whatsNext = 'webinar'
                   
                } else {
                    this.whatsNext = ''
                      
                }
        },
        onRowExpand(event) {
            this.expandedVideo = this.videos.filter(el => el.id == event.data.id)
        },
        async onRowReorder(event) {
            const effectedVideo = []
            this.videos.forEach(async (el, i) => {
                if(el.id == event.value[i].id ) {
                    effectedVideo.push(false)
                } else {
                    effectedVideo.push(true)       
                }
            });
           const check = effectedVideo.some(el => el == true)
            if(check) {
                for (let i = 0; i < effectedVideo.length ; i++) {
                    if(effectedVideo[i]) {
                        const payload = {
                            classroomId: event.value[i]?.classroom_id,
                            classroomLevelId: event.value[i]?.classroom_level_id,
                            title : event.value[i]?.title,
                            slug : event.value[i]?.slug,
                            shortDescription : event.value[i]?.short_description,
                            description : event.value[i]?.description,
                            video : event.value[i]?.video,
                            link : event.value[i]?.video_link,
                            duration : event.value[i]?.duration,
                            ordering : i + 1,
                            thumbnail : event.value[i]?.thumbnail,
                            publishedAt : moment(event.value[i]?.published_at).format(
                                'YYYY-MM-DD HH:mm:00'
                            ),
                            status: event.value[i]?.status
                        }
                        const data = {
                            id: event.value[i]?.id,
                            payload: payload
                        }
                        this.videos[i].ordering = i + 1
                        await this.updateVideo(data)
                    }
                }
                await this.fetchAllVideos(this.classroomId)   
                this.videos = this.videoList
                this.$toast.add({
                    severity: 'success',
                    summary: 'success',
                    detail: 'sukses dipindah',
                    life: 1000
                })
            }
        },

        showDeleteVideo(id) {
            this.videoId = id 
            this.displayDeleteVideo = true
        },
        closeDeleteVideo() {
            this.videoId = 0
            this.displayDeleteVideo = false
        },
        async videoDelete() {
            const indexDeleted = this.videos.findIndex(el => el.id == this.videoId)
            await this.deleteVideo(this.videoId)
            if (this.isSuccessVideo) {
                this.closeDeleteVideo()
                this.$toast.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: this.messageVideo,
                    life: 1000
                })
                this.videos.splice(indexDeleted,1)
                const effectedVideo = []
                this.videos.forEach(async (el, i) => {
                if(el.ordering == i + 1 ) {
                    effectedVideo.push(false)
                } else {
                    effectedVideo.push(true)       
                }
                });
                const check = effectedVideo.some(el => el == true)
                if(check) {
                    for (let i = 0; i < effectedVideo.length ; i++) {
                        if(effectedVideo[i]) {
                            const payload = {
                                classroomId: this.videos[i]?.classroom_id,
                                classroomLevelId: this.videos[i]?.classroom_level_id,
                                title : this.videos[i]?.title,
                                slug : this.videos[i]?.slug,
                                shortDescription : this.videos[i]?.short_description,
                                description : this.videos[i]?.description,
                                video : this.videos[i]?.video,
                                link : this.videos[i]?.video_link,
                                duration : this.videos[i]?.duration,
                                ordering : i + 1,
                                thumbnail : this.videos[i]?.thumbnail,
                                publishedAt : moment(this.videos[i]?.published_at).format(
                                    'YYYY-MM-DD HH:mm:00'
                                ),
                                status: this.videos[i]?.status
                            }
                            const data = {
                                id: this.videos[i]?.id,
                                payload: payload
                            }
                            this.videos[i].ordering = i + 1
                            await this.updateVideo(data)
                        }
                    }
                    await this.fetchAllVideos(this.classroomId)
                    this.videos = this.videoList
            
                    this.$toast.add({
                        severity: 'success',
                        summary: 'success',
                        detail: 'sukses dipindah',
                        life: 1000
                    })
                }
            } else {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Failed',
                    detail: this.messageVideo
                })
            }
        },
        clearFormSubject() {
            this.formSubject.title = ''
            this.formSubject.slug = ''
            this.formSubject.classroomId = 0
            this.formSubject.classroomLevelId = 0
            this.formSubject.publishedAt = moment().format('YYYY-MM-DD HH:mm:00')
            this.formSubject.shortDescription = ''
            this.formSubject.description = ''
            this.formSubject.thumbnail = ''
            this.formSubject.video = ''
            this.formSubject.link = ''
            this.formSubject.duration = ''
            this.formSubject.isActive = true
            this.formSubject.status = 1
            this.formSubject.ordering = 0
            this.format = 'video'
            this.$refs.videoUpload.value = null
            this.$refs.thumbnailUpload.value = null
            this.resolution = ''
        },
        async submit() {
            this.formSubject.status = 1
            this.formSubject.isActive = true
            this.formSubject.publishedAt = moment(this.formSubject.publishedAt).format(
                'YYYY-MM-DD HH:mm:00'
            )
            this.formSubject.classroomLevelId = this.classroom.levels[0].id
          
            this.formSubject.classroomId = Number(this.classroomId)
            if (this.videoId > 0) {
                if (
                    this.formSubject.title &&
                    this.formSubject.slug &&
                    this.formSubject.classroomId &&
                    this.formSubject.classroomLevelId
                ) {

                    const video = {
                        id: this.videoId,
                        payload: this.formSubject
                    }

                    if (this.format === 'video') {
                        this.formSubject.link = ''
                        await this.updateVideo(video)

                        if (this.isSuccessVideo) {
                            this.videoId = 0
                            await this.fetchAllVideos(this.classroomId)
                            this.videos = this.videoList
                            this.$toast.add({
                                severity: 'success',
                                summary: 'Success',
                                detail: this.messageVideo,
                                life: 1000
                            })
                            setTimeout(() => this.$router.go(-1), 1000)
                        } else {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Failed',
                                detail: this.messageVideo
                            })
                        }
                    } else {
                        await this.updateVideo(video)

                        if (this.isSuccessVideo) {
                            await this.fetchAllVideos(this.classroomId)
                            this.videos = this.videoList
                            this.$toast.add({
                                severity: 'success',
                                summary: 'Success',
                                detail: this.messageVideo,
                                life: 1000
                            })
                            setTimeout(() => this.$router.go(-1), 1000)
                        } else {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Failed',
                                detail: this.messageVideo
                            })
                        }
                    }



                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'semua form harus diisi',
                        life: 3000
                    })
                }

            } else {
               if( this.videos?.length) {
                   this.formSubject.ordering = this.videos?.length + 1
               } else {
                   this.formSubject.ordering =  1
               }

                
                if (
                    this.formSubject.title &&
                    this.formSubject.classroomId &&
                    this.formSubject.classroomLevelId &&
                    this.formSubject.duration &&
                    this.formSubject.slug
                ) {
                    if (/^[0-5][0-9]:[0-5][0-9]$/.test(this.formSubject.duration)) {
                        if (this.format === 'video') {
                            this.formSubject.link = ''
                            const formData = new FormData()
                            formData.append('title', this.formSubject.title)
                            formData.append('slug', this.formSubject.slug)
                            formData.append('classroom_id', this.formSubject.classroomId)
                            formData.append('classroom_level_id', this.formSubject.classroomLevelId)
                            formData.append('short_description', this.formSubject.shortDescription)
                            formData.append('description', this.formSubject.description)
                            formData.append('thumbnail', this.formSubject.thumbnail)
                            formData.append('video', this.formSubject.video)
                            // formData.append('video_link', this.formSubject.link)
                            formData.append('published_at', '"' + this.formSubject.publishedAt + '"')
                            formData.append('duration', this.formSubject.duration)
                            formData.append('ordering', this.formSubject.ordering)
                            formData.append('status', this.formSubject.status)

                            const accessToken = getAccessToken();

                            this.showUploadProgress = true
                            let iterasi = 1
                            axios
                                .post(
                                'https://api.sekolahdesain.id/classroom/private/api/v1/classroom/subject/',
                                formData,
                                {
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        Authorization: `Bearer ${accessToken}`,
                                    },
                                    onUploadProgress: (progressEvent) => {
                                        let percentage = Number(
                                            Math.round((progressEvent.loaded / progressEvent.total) * 50)
                                        )
                                        if(iterasi == 1) {
                                            if(percentage >= 49) {
                                                iterasi++
                                            }
                                            this.uploadPercentage = percentage
                                        } else { 
                                            this.uploadPercentage = percentage + 50
                                        }

                                        // console.log('proccess ',this.uploadPercentage)
                                        // console.log(progressEvent)

                                        // this.uploadPercentage = Number(
                                        //     Math.round((progressEvent.loaded / progressEvent.total) * 100)
                                        // )
                                    },
                                })
                                .then(async res => {
                                    if(res.data.success) {
                                        this.showUploadProgress = false

                                        if(this.resolution) {
                                            this.formResolution.resolution = this.resolution
                                            this.resolutionId = 0
                                            this.formResolution.link = res.data.data.video
                                            this.useFile = false
                                            this.submitResolution()
                                        }
                                        this.clearFormSubject()
                                        await this.fetchAllVideos(this.classroomId)
                                        this.videos = this.videoList

                                        this.$toast.add({
                                            severity: 'success',
                                            summary: 'Success',
                                            detail: 'Berhasil menambahkan video',
                                            life: 1000
                                        })
                                    } else {
                                        this.$toast.add({
                                            severity: 'error',
                                            summary: 'Failed',
                                            detail: 'Terjadi Kesalahan'
                                        })
                                    }
                                })
                                .catch(err => {
                                    this.$toast.add({
                                        severity: 'error',
                                        summary: 'Failed',
                                        detail: err.errors[0].message,
                                        life: 2000
                                    })
                                    this.$toast.add({
                                        severity: 'error',
                                        summary: 'Failed',
                                        detail: 'Upload gagal, cek file atau coba ulang!'
                                    })
                                })

                            // await this.addVideo(this.formSubject)

                            // if (this.isSuccessVideo) {
                            //     this.formSubject = {}
                            //     await this.fetchAllVideos(this.classroomId)
                            //     this.videos = this.videoList

                            //     this.$toast.add({
                            //         severity: 'success',
                            //         summary: 'Success',
                            //         detail: this.messageVideo,
                            //         life: 1000
                            //     })
                            // } else {
                            //     this.$toast.add({
                            //         severity: 'error',
                            //         summary: 'Failed',
                            //         detail: this.messageVideo
                            //     })
                            // }
                        } else {
                            await this.addVideo(this.formSubject)

                            if (this.isSuccessVideo) {
                                this.formSubject = {}
                            
                                this.$refs.thumbnailUpload.value = null
                                await this.fetchAllVideos(this.classroomId)
                            
                                this.videos = this.videoList
                                this.$toast.add({
                                    severity: 'success',
                                    summary: 'Success',
                                    detail: this.messageVideo,
                                    life: 1000
                                })
                                // setTimeout(() => this.$router.go(-1), 1000)
                            } else {
                                this.$toast.add({
                                    severity: 'error',
                                    summary: 'Failed',
                                    detail: this.messageVideo
                                })
                            }
                        }
                    } else {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Durasi maksimal 59:59',
                            life: 3000
                        })
                    }                    
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Semua form harus diisi',
                        life: 3000
                    })
                }
            }
        },

        convertStatus() {
            if(this.videoId > 0) {
                if (this.formSubjectEdit.isActive) {
                    this.formSubjectEdit.status = 1
                } else {
                    this.formSubjectEdit.status = 0
                }
            } else {
                if (this.formSubject.isActive) {
                    this.formSubject.status = 1
                } else {
                    this.formSubject.status = 0
                }
            }
        },
        uploadThumbnail(event) {
            this.formSubject.thumbnail = event.target.files[0]
        },
        uploadVideo(event) {
            // console.log(event)
            if (event.target.files[0].type == 'video/mp4' || event.target.files[0].name.includes('.mp4')) {
                this.formSubject.video = event.target.files[0];
            } else {
                this.$refs.videoUpload.value = null
                this.$toast.add({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'File video harus bertipe MP4',
                    life: 3000
                })
            }
        },
        uploadThumbnailEdit(event) {
            this.formSubjectEdit.thumbnail = event.target.files[0]
        },
        uploadVideoEdit(event) {
            if (event.target.files[0].type == 'video/mp4' || event.target.files[0].name.includes('.mp4')) {
                this.formSubjectEdit.video = event.target.files[0];
            } else {
                this.$refs.videoUploadEdit.value = null
                this.$toast.add({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'File video harus bertipe MP4',
                    life: 3000
                })
            }
        },

        nextStep(){
            let confirmation
            if(!this.videos?.length) {
                confirmation = confirm('Tidak ada video dalam kelas ini, apakah yakin ingin ke langkah selanjutnya?')
            } else {
                confirmation = confirm('Apakah yakin ingin ke langkah selanjutnya?')
            }

            if(confirmation) {
                if(this.whatsNext != '') {
                    this.$router.push('/classroom/' + this.classroom.id + '/step/' + this.whatsNext)
                } else {
                    this.$router.push('/classroom/' + this.classroom.id + '/detail')
                }
            }
        },
         videoPreview(data, id) {
            // console.log(data)
            if(id > 0) {
                const res = data.resolutions.filter(el => el.id == id)
                this.selectedVideo.title = data.title + '(' + res[0].resolution + ')'
                this.selectedVideo.video = res[0].link
            } else {
                this.selectedVideo = data
            }
            this.videoPreviewModal = true
        },
        closeVideoPreview() {
            this.videoPreviewModal = false
            this.selectedVideo = {}
        },

        async showEditVideo(id) {
            this.videoId = id
            await this.getSubject()
            this.displayEditVideo = true
        },

        async getSubject() {
            await this.fetchDetailVideo(this.videoId)
            if (this.video) {
                this.formSubjectEdit.title = this.video.title
                this.formSubjectEdit.slug = this.video.slug
                this.formSubjectEdit.shortDescription = this.video.short_description
                this.formSubjectEdit.description = this.video.description
                this.formSubjectEdit.video = this.video.video
                this.formSubjectEdit.link = this.video.video_link
                this.formSubjectEdit.duration = this.video.duration
                this.formSubjectEdit.ordering = this.video.ordering
                this.formSubjectEdit.thumbnail = this.video.thumbnail
                this.formSubjectEdit.publishedAt = moment(this.video.published_at).format(
                    'YYYY-MM-DD HH:mm:ss'
                )
                const active = this.video.status
                if (active == 1) {
                    this.formSubjectEdit.isActive = true
                } else {
                    this.formSubjectEdit.isActive = false
                }
                this.format = 'video'
            }
        },
        closeEditVideo() {
            this.displayEditVideo = false
            this.videoId = 0
            this.formSubjectEdit.title = ''
            this.formSubjectEdit.slug = ''
            this.formSubjectEdit.shortDescription = ''
            this.formSubjectEdit.description = ''
            this.formSubjectEdit.video = ''
            this.formSubjectEdit.link = ''
            this.formSubjectEdit.duration = ''
            this.formSubjectEdit.ordering = 0
            this.formSubjectEdit.thumbnail = ''
            this.formSubjectEdit.publishedAt = ''
            this.formSubjectEdit.status = 0
            this.formSubjectEdit.isActive = false
            this.format = 'video'
            this.$refs.videoUploadEdit.value = null
            this.$refs.thumbnailUploadEdit.value = null
        },

        async submitEdit() {
            this.formSubjectEdit.status = 1
            this.formSubjectEdit.isActive = true
            this.formSubjectEdit.publishedAt = moment(this.formSubjectEdit.publishedAt).format(
                'YYYY-MM-DD HH:mm:00'
            )
          
            this.formSubjectEdit.classroomId = Number(this.classroomId)
            this.formSubjectEdit.classroomLevelId = this.classroom.levels[0].id

            if (this.videoId > 0) {
                this.formSubjectEdit.classroomLevelId = this.classroom.levels[0].id
                
                if (
                    this.formSubjectEdit.title &&
                    this.formSubjectEdit.classroomId &&
                    this.formSubjectEdit.classroomLevelId &&
                    this.formSubjectEdit.duration &&
                    this.formSubjectEdit.slug &&
                    this.formSubjectEdit.video
                ) {
                    if (/^[0-5][0-9]:[0-5][0-9]$/.test(this.formSubjectEdit.duration)) {
                        const video = {
                            id: this.videoId,
                            payload: this.formSubjectEdit
                        }
                        if (this.format === 'video') {
                            this.formSubjectEdit.link = ''
                            const formData = new FormData()
                            formData.append('title', this.formSubjectEdit.title)
                            formData.append('slug', this.formSubjectEdit.slug)
                            formData.append('classroom_id', this.formSubjectEdit.classroomId)
                            formData.append('classroom_level_id', this.formSubjectEdit.classroomLevelId)
                            formData.append('short_description', this.formSubjectEdit.shortDescription)
                            formData.append('description', this.formSubjectEdit.description)
                            formData.append('thumbnail', this.formSubjectEdit.thumbnail)
                            formData.append('video', this.formSubjectEdit.video)
                            // formData.append('video_link', this.formSubjectEdit.link)
                            formData.append('published_at', '"' + this.formSubjectEdit.publishedAt + '"')
                            formData.append('duration', this.formSubjectEdit.duration)
                            formData.append('ordering', this.formSubjectEdit.ordering)
                            formData.append('status', this.formSubjectEdit.status)

                            const accessToken = getAccessToken();

                            this.showUploadProgressUpdate = true
                            axios
                                .put(
                                'https://api.sekolahdesain.id/classroom/private/api/v1/classroom/subject/' + this.videoId,
                                formData,
                                {
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        Authorization: `Bearer ${accessToken}`,
                                    },
                                    onUploadProgress: (progressEvent) => {
                                        this.uploadPercentageUpdate = Number(
                                            Math.round((progressEvent.loaded / progressEvent.total) * 100)
                                        )
                                        // console.log(this.uploadPercentageUpdate)
                                        // console.log((progressEvent.loaded / progressEvent.total) * 100)
                                    },
                                })
                                .then(async res => {
                                    if(res.data.success) {
                                        this.showUploadProgressUpdate = false
                                        this.closeEditVideo()
                                        await this.fetchAllVideos(this.classroomId)
                                        this.videos = this.videoList

                                        this.$toast.add({
                                            severity: 'success',
                                            summary: 'Success',
                                            detail: 'Berhasil menambahkan video',
                                            life: 1000
                                        })
                                    } else {
                                        this.$toast.add({
                                            severity: 'error',
                                            summary: 'Failed',
                                            detail: 'Terjadi Kesalahan'
                                        })
                                    }
                                })
                                .catch(err => {
                                    this.$toast.add({
                                        severity: 'error',
                                        summary: 'Failed',
                                        detail: err.errors[0].message,
                                        life: 2000
                                    })
                                    this.$toast.add({
                                        severity: 'error',
                                        summary: 'Failed',
                                        detail: 'Upload gagal, cek file atau coba ulang!'
                                    })
                                })
                            // await this.updateVideo(video)

                            // if (this.isSuccessVideo) {
                            //     this.closeEditVideo()
                            //     await this.fetchAllVideos(this.classroomId)
                            //     this.videos = this.videoList

                            //     this.$toast.add({
                            //         severity: 'success',
                            //         summary: 'Success',
                            //         detail: this.messageVideo,
                            //         life: 1000
                            //     })
                            // } else {
                            //     this.$toast.add({
                            //         severity: 'error',
                            //         summary: 'Failed',
                            //         detail: this.messageVideo
                            //     })
                            // }
                        } else {
                            await this.updateVideo(video)

                            if (this.isSuccessVideo) {
                                this.closeEditVideo()
                                await this.fetchAllVideos(this.classroomId)
                                this.videos = this.videoList

                                this.$toast.add({
                                    severity: 'success',
                                    summary: 'Success',
                                    detail: this.messageVideo,
                                    life: 1000
                                })
                            } else {
                                this.$toast.add({
                                    severity: 'error',
                                    summary: 'Failed',
                                    detail: this.messageVideo
                                })
                            }
                        }
                    } else {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Durasi maksimal 59:59',
                            life: 3000
                        })
                    }                    
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Semua form harus diisi',
                        life: 3000
                    })
                }
            }
        },
        addNewAsset() {
            this.displayModalAsset = true
            this.formAsset.name = ''
        },
        closeModalAsset() {
            this.displayModalAsset = false
            this.formAsset.name = ''
            this.formAsset.file = null
            this.$refs.assetUpload.value = null
        },
        uploadAsset(event) {
            this.formAsset.file = event.target.files[0];
        },
        async submitAsset() {
            // console.log(this.expandedVideo)
            if (this.formAsset.name &&
                this.formAsset.file) {
                    const formData = new FormData()
                    formData.append('name', this.formAsset.name)
                    formData.append('file', this.formAsset.file)
                    const accessToken = getAccessToken();

                    this.showUploadProgressAsset = true
                    axios
                        .post(
                        'https://api.sekolahdesain.id/classroom/private/api/v1/classroom/subject/' + this.expandedVideo[0].id + '/asset',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                Authorization: `Bearer ${accessToken}`,
                            },
                            onUploadProgress: (progressEvent) => {
                                this.uploadPercentageAsset = Number(
                                    Math.round((progressEvent.loaded /progressEvent.total) * 100)
                                )
                            },
                        })
                        .then(async res => {
                            this.showUploadProgressAsset = false
                            if(res.data.success) {
                                this.$toast.add({
                                    severity: 'success',
                                    summary: 'Success',
                                    detail: 'Berhasil menambahkan asset',
                                    life: 1000
                                })
                                this.closeModalAsset()
                                await this.fetchAllVideos(this.classroomId)
                                this.videos = this.videoList
                            } else {
                                this.$toast.add({
                                    severity: 'error',
                                    summary: 'Error',
                                    detail: 'Terjadi kesalahan, Coba kembali',
                                    life: 3000
                                })
                            }
                        })
                        .catch(err => {
                            this.showUploadProgressAsset = false
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: err.errors[0].message,
                                life: 3000
                            })
                        })

                    // const data = {
                    //     id: this.expandedVideo[0].id,
                    //     payload: this.formAsset,
                    // }
                    // await this.addAssetVideo(data)
                    // if(this.isSuccessVideo) {
                    //     this.$toast.add({
                    //         severity: 'success',
                    //         summary: 'Success',
                    //         detail: this.messageVideo,
                    //         life: 1000
                    //     })
                    //     this.closeModalAsset()
                    //     await this.fetchAllVideos(this.classroomId)
                    //     this.videos = this.videoList
                    // } else {
                    //     this.$toast.add({
                    //         severity: 'error',
                    //         summary: 'Error',
                    //         detail: this.messageVideo,
                    //         life: 3000
                    //     })
                    // }
            } else {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Semua form harus diisi',
                    life: 3000
                })
            }
        },
        addNewResolution() {
            this.displayModalResolution = true
            this.formResolution.resolution = ''
            this.formResolution.link = ''
            this.resolutionId = 0
            this.useFile = true
            if(this.videoResolutionFile) {
                this.$refs.resolutionUpload.value = null
                this.videoResolutionFile = null
            }
        },
        closeModalResolution() {
            this.displayModalResolution = false
            this.formResolution.resolution = ''
            this.formResolution.link = ''
            this.resolutionId = 0
            this.useFile = true
            if(this.videoResolutionFile) {
                this.$refs.resolutionUpload.value = null
                this.videoResolutionFile = null
            }
        },
        uploadResolution(event) {
            if (event.target.files[0].type == 'video/mp4' || event.target.files[0].name.includes('.mp4')) {
                this.videoResolutionFile = event.target.files[0]  
            } else {
                this.$refs.resolutionUpload.value = null
                this.$toast.add({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'File video harus bertipe MP4',
                    life: 3000
                })
            }
        },
        submitResolution() {
            // console.log(this.expandedVideo)
            if (this.useFile) {
                this.formResolution.link = this.videoResolutionFile
            }
            if ( this.formResolution.resolution &&
                this.formResolution.link) {
                    const formData = new FormData()
                    formData.append('resolution', this.formResolution.resolution)
                    formData.append('link', this.formResolution.link)
                    const accessToken = getAccessToken();
                    if (this.resolutionId == 0) {
                        // console.log(this.formResolution)
                        this.showUploadProgressResolution = true
                        axios
                            .post('https://api.sekolahdesain.id/classroom/private/api/v1/classroom/subject/'+ this.expandedVideo[0].id +'/resolution',
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                    Authorization: `Bearer ${accessToken}`,
                                },
                                onUploadProgress: (progressEvent) => {
                                    this.uploadPercentageResolution = Number(
                                        Math.round((progressEvent.loaded / progressEvent.total) * 100)
                                    )
                                },
                            })
                            .then(async res => {
                                if(res.data.success) {
                                    this.showUploadProgressResolution = false
                                    this.closeModalResolution()
                                    await this.fetchAllVideos(this.classroomId)
                                    this.videos = this.videoList

                                    this.$toast.add({
                                        severity: 'success',
                                        summary: 'Success',
                                        detail: 'Berhasil menambahkan resolusi video',
                                        life: 1000
                                    })
                                } else {
                                    this.$toast.add({
                                        severity: 'error',
                                        summary: 'Failed',
                                        detail: 'Terjadi Kesalahan'
                                    })
                                }
                            })
                            .catch(err => {
                                this.$toast.add({
                                    severity: 'error',
                                    summary: 'Failed',
                                    detail: err.errors[0].message,
                                    life: 2000
                                })
                                this.$toast.add({
                                    severity: 'error',
                                    summary: 'Failed',
                                    detail: 'Upload gagal, cek file atau coba ulang!'
                                })
                            })
                    } else {
                        this.showUploadProgressResolution = true
                        axios
                            .put('https://api.sekolahdesain.id/classroom/private/api/v1/classroom/resolution/' + this.resolutionId,
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                    Authorization: `Bearer ${accessToken}`,
                                },
                                onUploadProgress: (progressEvent) => {
                                    this.uploadPercentageResolution = Number(
                                        Math.round((progressEvent.loaded / progressEvent.total) * 100)
                                    )
                                },
                            })
                            .then(async res => {
                                if(res.data.success) {
                                    this.showUploadProgressResolution = false
                                    this.closeModalResolution()
                                    await this.fetchAllVideos(this.classroomId)
                                    this.videos = this.videoList

                                    this.$toast.add({
                                        severity: 'success',
                                        summary: 'Success',
                                        detail: 'Berhasil mengubah resolusi video',
                                        life: 1000
                                    })
                                } else {
                                    this.$toast.add({
                                        severity: 'error',
                                        summary: 'Failed',
                                        detail: 'Terjadi Kesalahan'
                                    })
                                }
                            })
                            .catch(err => {
                                this.$toast.add({
                                    severity: 'error',
                                    summary: 'Failed',
                                    detail: err.response.data.errors[0].message,
                                    life: 2000
                                })
                                this.$toast.add({
                                    severity: 'error',
                                    summary: 'Failed',
                                    detail: 'Upload gagal, cek file atau coba ulang!'
                                })
                                setTimeout(() => {
                                    this.closeModalResolution()
                                }, 1000)
                            })
                    }
            } else {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Semua form harus diisi',
                    life: 3000
                })
            }
        },
        showEditResolution(data) {
            this.displayModalResolution = true
            this.resolutionId = data.id
            this.formResolution.resolution = data.resolution
            this.formResolution.link = data.link
            this.useFile = false
        },
        showDeleteResolution(data) {
            this.displayDeleteResolution = true
            this.resolutionId = data.id
            this.formResolution.resolution = data.resolution
        },
        closeDeleteResolution() {
            this.displayDeleteResolution = false
            this.resolutionId = 0
            this.formResolution.resolution = ''
        },
        async resolutionDelete() {
            await this.removeResolution(this.resolutionId)
            if (this.isSuccessVideo) {
                this.closeDeleteResolution()
                this.$toast.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: this.messageVideo,
                    life: 1000
                })
                await this.fetchAllVideos(this.classroomId)
                this.videos = this.videoList
            } else {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Failed',
                    detail: this.messageVideo
                })
            }
        },
    } 
}
</script>

<style scoped>
.toggle-checkbox:checked {
  @apply: right-0 border-green-400;
  right: 0;
  border-color: #10B981;
}
.toggle-checkbox:checked + .toggle-label {
  @apply: bg-green-400;
  background-color: #10B981;
}
::v-deep(.vc-select select) {
  background-image: unset;
}
</style>